import { render, staticRenderFns } from "./staticConfig.vue?vue&type=template&id=31ddc85e&"
import script from "./staticConfig.vue?vue&type=script&lang=js&"
export * from "./staticConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports